import { buildActivityLogDetailRows } from "./activityLogDetail";

const coaIncludesName = (type) => [1, 4, 5, 6].includes(Number(type));
const coaIncludesLoad = (type) => [2, 4, 5, 7].includes(Number(type));
const coaIncludesTariff = (type) => [3, 4, 6, 7].includes(Number(type));

const pickDisplayValue = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined) continue;
    const text =
      typeof value === "number" ? String(value) : String(value).trim();
    if (text) return text;
  }
  return "";
};

const formatCoaApplicantDisplayName = (row, useApplicantFields = false) => {
  if (!row) return "";

  if (!useApplicantFields) {
    const currentName = row.currentOwnerName;
    if (currentName && String(currentName).trim()) {
      return String(currentName).trim();
    }
  }

  const guardianLabel =
    row.applicantGuardianType == 1
      ? "S/O"
      : row.applicantGuardianType == 2
        ? "D/O"
        : row.applicantGuardianType == 3
          ? "W/O"
          : row.applicantGuardianType == 4
            ? "C/O"
            : "";

  return `${row.applicantName || ""} ${guardianLabel} ${row.applicantGuardianName || ""}`.trim();
};

export function buildCoaActivityLogApplicationDetails(rowData = {}) {
  const type = Number(rowData?.changeOfAttributesType);

  const currentName = pickDisplayValue(
    rowData.currentOwnerName,
    formatCoaApplicantDisplayName(rowData, false),
    rowData.applicantName,
    rowData.consumerName,
  );
  const newName = pickDisplayValue(
    formatCoaApplicantDisplayName(rowData, true),
    rowData.newName,
    rowData.applicantName,
    rowData.consumerName,
  );

  const currentLoad = pickDisplayValue(
    rowData.currentSanctionLoad,
    rowData.sanctionedLoad,
  );
  const newLoad = pickDisplayValue(
    rowData.newSanctionLoad,
    rowData.sanctionedLoad,
  );

  const currentTariff = pickDisplayValue(
    rowData.currentTariff,
    rowData.tariffDesc,
  );
  const newTariff = pickDisplayValue(rowData.newTariff, rowData.tariffDesc);

  return {
    applicationId: rowData.applicationId || "",
    name: coaIncludesName(type)
      ? pickDisplayValue(newName, currentName)
      : currentName,
    sanctionedLoad: coaIncludesLoad(type)
      ? pickDisplayValue(newLoad, currentLoad)
      : currentLoad,
    tariff: coaIncludesTariff(type)
      ? pickDisplayValue(newTariff, currentTariff)
      : currentTariff,
    cnic: rowData.applicantCNIC || rowData.consumerCNIC || "",
    phoneNo: rowData.applicantMobileNo || rowData.applicantPhoneNo || "",
    referenceNo: rowData.referenceNumber || "",
    consumerId: rowData.customerId || "",
    meterType: rowData.meterType || "",
  };
}

export const COA_ACTIVITY_STEPS = [
  {
    id: 1,
    label: "Document Submission",
    slaDays: 0,
    aliases: ["Documents Uploading"],
  },
  {
    id: 2,
    label: "Document Verification",
    slaDays: 1,
    aliases: ["Documents Verification"],
  },
  {
    id: 3,
    label: "Wiring Test Report",
    slaDays: 1,
  },
  {
    id: 4,
    label: "Arrear Verification",
    slaDays: 1,
    aliases: ["Arrears Verification"],
  },
  {
    id: 5,
    label: "Field Survey & Cost Estimation",
    slaDays: 1,
    aliases: ["Field Survey"],
  },
  { id: 6, label: "DN Approval", slaDays: 1 },
  {
    id: 7,
    label: "DN Submission",
    slaDays: 30,
    aliases: ["DN Payment Submission"],
  },
  { id: 8, label: "DN Payment Verification", slaDays: 1 },
  {
    id: 9,
    label: "Sundry Job Order",
    slaDays: 1,
    aliases: ["Sundary Jobs Order", "Sundry Jobs Order"],
  },
  {
    id: 10,
    label: "Ready For Billing",
    slaDays: 1,
    aliases: ["Ready for Billing"],
  },
  { id: 11, label: "Completed", slaDays: 1 },
];

export function buildCoaActivityLogDetailRows(
  historyItems = [],
  currentStatus = {},
  formatDateFn,
) {
  return buildActivityLogDetailRows(historyItems, currentStatus, formatDateFn, {
    steps: COA_ACTIVITY_STEPS,
    stepNameField: "coaProgStatusName",
    totalExcludeStepLabels: ["DN Submission", "DN Payment Submission"],
  });
}
